import React from "react";
import { Link } from "react-router-dom";

const DEFAULT_LOGO = "/assets/images/logo/logo-002.png";

export function DefaultBrand(props) {
  return (
    <Link to="/home">
      <img src={DEFAULT_LOGO} alt="" style={{ marginTop: "0.2em" }} height="55px" className="m-0 p-0" />
    </Link>
  );
}

export default function NavBarBrand(props) {
  let { styles } = props;

  if (!styles || !styles.size) {
    return <DefaultBrand />;
  }

  let logoURL = styles?.get("navbarLogo") || DEFAULT_LOGO;

  return (
    <React.Fragment>
      <div style={{ display: "flex" }}>
        <div style={{ fontSize: "1rem" }}>
          <Link to={"/home"}>
            <img src={logoURL} height={`${styles.get("logoHeight") || 40}px`} alt="" />
          </Link>
          <br />
          <span style={{ fontSize: "1rem", marginTop: "0", color: "#ddd" }}>
            <Strapline text={styles.get("strapline1")} />
            <Strapline text={styles.get("strapline2")} linkto={styles.get("strapline2link")} separator="|" />
          </span>
        </div>
        <StraplineImages urls={styles.get("straplineImages")} />
      </div>
    </React.Fragment>
  );
}
